// extracted by mini-css-extract-plugin
export default {"Accordian":"Accordian_Accordian__xmSIF","active":"Accordian_active__iRiR3","icon":"Accordian_icon__uGrq0","content":"Accordian_content__Aqf+e","header":"Accordian_header__qprS5"};